module.exports = __webpack_public_path__ + "static/media/gremp.81328454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gremp.jpg
// module id = 204
// module chunks = 0